































import moment from "moment";
import Vue from "vue";
import { mapGetters } from "vuex";

// Model
import VFaIcon from "@/components/VFaIcon.vue";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetDataFlowFeedbacksByTransactionIdCommand, GetDataFlowFeedbacksByTransactionIdResData } from "@/model/communication/dataFlow/GetDataFlowFeedbacksByTransactionIdCommand";
import { Transaction } from "@/model/data/cashFlow/Transaction";
import { DataFlowFeedback, FeedbackType, GetI18nStringFromDataFlowStep, GetI18nStringFromFeedbackType } from "@/model/data/dataflow/DataFlowFeedback";

export default Vue.extend({
    components: { VFaIcon },
    data() {
        return {
            moment,
            loading: false,
            showAllFeedbacks: false,
            feedbacks: [],
        };
    },
    props: { transaction: Transaction },
    computed: {
        ...mapGetters(["userTimeFormat", "userDateFormat", "longDateFormat", "authUserHasPrivilege"]),
        computedFeedbacks() {
            if (this.showAllFeedbacks) return this.feedbacks;
            else if (this.feedbacks != null && this.feedbacks.length > 0) return [this.feedbacks[this.feedbacks.length - 1]];
            else return [];
        },
    },
    watch: {
        transaction() {
            this.GetDataFlowFeedbacksByTransactionId();
        },
    },
    methods: {
        GetI18nStringFromDataFlowStep,
        GetI18nStringFromFeedbackType,
        async GetDataFlowFeedbacksByTransactionId() {
            this.loading = true;

            let response: GetDataFlowFeedbacksByTransactionIdResData = await new GetDataFlowFeedbacksByTransactionIdCommand(this.transaction.id).execute();
            // console.log("Response", response);

            if (response.responseStatus == ApiResponseStatusEnum.Success) {
                this.feedbacks = response.feedbacks.sort((a, b) => a.id - b.id) as DataFlowFeedback[];
                this.feedbacks.forEach((feedback: DataFlowFeedback) => {
                    var color = "primary";
                    var icon = "fa-check";
                    switch (feedback.type) {
                        case FeedbackType.Ok:
                        case FeedbackType.Start:
                            color = "success";
                            icon = "fa-check";
                            break;
                        case FeedbackType.Warning:
                        case FeedbackType.Unknown:
                            color = "warning";
                            icon = "fa-exclamation";
                            break;
                        case FeedbackType.Error:
                            color = "error";
                            icon = "fa-times";
                            break;
                        default:
                            break;
                    }
                    (feedback as any).dotColor = color;
                    (feedback as any).dotIcon = icon;
                });
            }

            this.loading = false;
        },
        formattedDate(date) {
            return moment(date).format(this.longDateFormat(true, true, true));
        },
    },
    mounted() {
        this.GetDataFlowFeedbacksByTransactionId();
    },
});
